import Vue from 'vue';
import Router from 'vue-router';
import { speedReportMixin } from '@/plugins/mixin/speedReport';
import appConfig from '../../runtime/config';

Vue.use(Router);

// eslint-disable-next-line no-underscore-dangle
if (!Router.prototype.__isModify) {
  // 避免重复修改
  // eslint-disable-next-line no-underscore-dangle
  Router.prototype.__isModify = true;
  // 替换resolve支持绝对路径(主要是外链)
  Router.prototype.resolve = ((resolve) => function (to, current, append) {
    const next = typeof to === 'string' ? { path: to } : to;
    const result = resolve.call(this, to, current, append);
    // 让route支持完整的URL
    if (/^(?:https?:)?\/\//.test(next.path)) {
      // 去掉seach和hash，route内部会自动从query和hash获取数据拼到path上
      const toPath = next.path.replace(/^([^?#]+)[?#].+$/, '$1');
      // route和resolved被Object.freeze了，需要通过Object.assign来修改值
      result.route = { ...result.route, fullPath: toPath, path: toPath };
      result.resolved = { ...result.resolved, fullPath: toPath, path: toPath };
      result.location.path = toPath;
      result.normalizedTo.path = toPath;
      result.href = next.path;
    }
    return result;
  })(Router.prototype.resolve);
  // 只支持3.0.2及以后的版本
  Vue.options.components.RouterLink.options.render = ((render) => function (createElement) {
    return render.call(this, (tag, data, slots) => {
      const vnode = createElement(tag, data, slots);
      // 直出版调用指令的stringify钩子
      if (process.env.VUE_ENV === 'server') {
        const { directives } = this.$vnode.data;
        if (directives && directives.length) {
          directives.forEach((directive) => {
            if (directives[directive.name] && typeof directives[directive.name].stringify === 'function') {
              directives[directive.name].stringify(vnode, directive);
            }
          });
        }
      }
      return vnode;
    });
  })(Vue.options.components.RouterLink.options.render);
}

const addMixin = (c) => {
  if (Array.isArray(c.default.mixins)) {
    c.default.mixins.push(speedReportMixin);
  } else {
    c.default.mixins = [speedReportMixin];
  }
  return c;
};

// eslint-disable-next-line import/prefer-default-export
export const createRouter = function createRouter() {
  const router = new Router({
    mode: 'history',
    base: `${appConfig.rootPath}pages/`,
    routes: [
      {
        path: '/person.html',
        name: 'person',
        component: async () => addMixin(await import('../pages/personal/index.vue')),
      },
      {
        path: '/qyg_index.html',
        name: 'qyg_index',
        component: async () => addMixin(await import('../pages/qyg_index/index.vue')),
      },
      {
        path: '/group_detail.html',
        name: 'group_detail',
        component: async () => addMixin(await import('../pages/group_detail/index.vue')),
      },
      {
        path: '/topic.html',
        name: 'topic',
        component: async () => addMixin(await import('../pages/topic/index.vue')),
      },
    ],
  });

  if (process.env.VUE_ENV !== 'server') {
    router.beforeEach((to, from, next) => {
      const toPath = to.matched.length > 0 ? to.matched[0].path : null;
      const fromPath = from.matched.length > 0 ? from.matched[0].path : null;
      if (to.matched.length === 0 || (fromPath !== null && toPath !== fromPath)) {
        if (/^(?:https?:)?\/\//.test(to.fullPath)) {
          window.location.href = to.fullPath;
        } else {
          window.location.href = (router.options.base || '').replace(/\/$/, '') + to.fullPath;
        }
        next(false);
      } else {
        next();
      }
    });
  }

  return router;
};
